import apiClient from 'services/_infra/apiClient';

// ─── Conversations ────────────────────────────────────────────────────────────

export async function createConversation(data) {
  const response = await apiClient.post('/messaging/conversations', data);
  return response.data;
}

export async function getConversations(params = {}) {
  const response = await apiClient.get('/messaging/conversations', { params });
  return response.data;
}

export async function getConversation(conversationId) {
  const response = await apiClient.get(`/messaging/conversations/${conversationId}`);
  return response.data;
}

export async function updateConversation(conversationId, data) {
  const response = await apiClient.put(`/messaging/conversations/${conversationId}`, data);
  return response.data;
}

// ─── Participants ─────────────────────────────────────────────────────────────

export async function addParticipant(conversationId, data) {
  const response = await apiClient.post(
    `/messaging/conversations/${conversationId}/participants`,
    data,
  );
  return response.data;
}

export async function removeParticipant(conversationId, userId) {
  const response = await apiClient.delete(
    `/messaging/conversations/${conversationId}/participants/${userId}`,
  );
  return response.data;
}

export async function updateParticipantRole(conversationId, userId, data) {
  const response = await apiClient.patch(
    `/messaging/conversations/${conversationId}/participants/${userId}/role`,
    data,
  );
  return response.data;
}

export async function transferOwnership(conversationId, data) {
  const response = await apiClient.post(
    `/messaging/conversations/${conversationId}/transfer-ownership`,
    data,
  );
  return response.data;
}

// ─── Messages ─────────────────────────────────────────────────────────────────

export async function getMessages(conversationId, params = {}) {
  const response = await apiClient.get(`/messaging/conversations/${conversationId}/messages`, {
    params,
  });
  return response.data;
}

export async function getMessageContext(conversationId, messageId, params = {}) {
  const response = await apiClient.get(
    `/messaging/conversations/${conversationId}/messages/${messageId}/context`,
    { params },
  );
  return response.data;
}

export async function sendMessage(conversationId, data) {
  const response = await apiClient.post(
    `/messaging/conversations/${conversationId}/messages`,
    data,
  );
  return response.data;
}

export async function editMessage(conversationId, messageId, data) {
  const response = await apiClient.put(
    `/messaging/conversations/${conversationId}/messages/${messageId}`,
    data,
  );
  return response.data;
}

export async function deleteMessage(conversationId, messageId) {
  const response = await apiClient.delete(
    `/messaging/conversations/${conversationId}/messages/${messageId}`,
  );
  return response.data;
}

export async function getMessageReactions(conversationId, messageId) {
  const response = await apiClient.get(
    `/messaging/conversations/${conversationId}/messages/${messageId}/reactions`,
  );
  return response.data;
}

export async function addReaction(conversationId, messageId, data) {
  const response = await apiClient.post(
    `/messaging/conversations/${conversationId}/messages/${messageId}/reactions`,
    data,
  );
  return response.data;
}

export async function deleteReaction(conversationId, messageId, data = {}) {
  const response = await apiClient.delete(
    `/messaging/conversations/${conversationId}/messages/${messageId}/reactions`,
    { data },
  );
  return response.data;
}

// ─── Media ────────────────────────────────────────────────────────────────────

export async function uploadMedia(conversationId, formData) {
  const response = await apiClient.post(
    `/messaging/conversations/${conversationId}/media`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
}

// ─── Actions ──────────────────────────────────────────────────────────────────

export async function markAsRead(conversationId, data = {}) {
  const response = await apiClient.post(`/messaging/conversations/${conversationId}/read`, data);
  return response.data;
}

export async function sendTypingIndicator(conversationId, data) {
  const response = await apiClient.post(`/messaging/conversations/${conversationId}/typing`, data);
  return response.data;
}

// E2EE

export async function registerEncryptionKey(data) {
  const response = await apiClient.post('/messaging/encryption/keys', data);
  return response.data;
}

export async function getUserEncryptionKeys(userId) {
  const response = await apiClient.get(`/messaging/encryption/keys/${userId}`);
  return response.data;
}

export async function revokeEncryptionKey(deviceId) {
  const response = await apiClient.delete(`/messaging/encryption/keys/${deviceId}`);
  return response.data;
}

export async function storeConversationEncryptionKey(conversationId, data) {
  const response = await apiClient.post(
    `/messaging/encryption/conversation/${conversationId}/keys`,
    data,
  );
  return response.data;
}

export async function getMyConversationEncryptionKey(conversationId, deviceId) {
  const response = await apiClient.get(`/messaging/encryption/conversation/${conversationId}/keys`, {
    params: { deviceId },
  });
  return response.data;
}

export async function getMissingEncryptionKeys(deviceId) {
  const response = await apiClient.get('/messaging/encryption/missing-keys', {
    params: { deviceId },
  });
  return response.data;
}

export async function requestEncryptionKeys(deviceId) {
  const response = await apiClient.post('/messaging/encryption/request-keys', { deviceId });
  return response.data;
}

export async function provideConversationEncryptionKey(conversationId, data) {
  const response = await apiClient.post(
    `/messaging/encryption/conversation/${conversationId}/provide-key`,
    data,
  );
  return response.data;
}
